import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { AdminCmsCatalogKey } from './cms.i18n.js';
import { ADMIN_CMS_CATALOG } from './cms.i18n.js';

export type AdminCmsMessageId = `adminCms:${AdminCmsCatalogKey}`;

const PREFIX_LENGTH = 'adminCms:'.length;

/** `t()` for the stop-gap `adminCms:` scope (see `cms.i18n.ts`). */
export function useCmsT(): { t: (id: AdminCmsMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: AdminCmsMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as AdminCmsCatalogKey;
      const raw = ADMIN_CMS_CATALOG[locale][key] ?? ADMIN_CMS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
